module.exports = __webpack_public_path__ + "img/bs2.de08917d.png";